
import Axios, {
  AxiosError,
  AxiosResponse,
} from "axios";
import { Primitive } from "type-fest";
import {
  getAxiosParams,
  getBasicAuthCredentials,
  manageErrorResponse,
  sanitizeApiController,
  transformRequestData,
} from "./api-schema";
import { ApiDetailType } from "./api-types";
import HttpException from "utils/http.exception";

export interface InitApiRequest {
  apiDetails: ApiDetailType;
  pathVariables?: GenericObj<Primitive>;
  params?: { [key: string]: Primitive | Array<GenericObj<Primitive>> };
  requestData?: any;
  signal?: AbortSignal;
  headers?: any;
}

Axios.interceptors.response.use(
  async (response) => {
    return response;
  },
  (error: AxiosError<BackendErrorResponse<unknown>>) => {
    return Promise.reject(error);
  },
);



const initApiRequest = async <TData>({
  apiDetails,
  pathVariables,
  params,
  headers,
  signal,
  requestData,
}: InitApiRequest): Promise<AxiosResponse<TData> | undefined> => {
  const sanitizedDetails = sanitizeApiController(
    { ...apiDetails },
    pathVariables,
  );

  const axiosParams = getAxiosParams(sanitizedDetails, headers);
  try {
    return await Axios.request<TData>({
      ...axiosParams,
      params,
      signal: signal ?? axiosParams.signal,
      data: transformRequestData(sanitizedDetails, requestData),
      withCredentials: true,
      auth: getBasicAuthCredentials(sanitizedDetails.requestBodyType),
      meta: {
        hasEncryptedResponse: sanitizedDetails.hasEncryptedResponse as boolean,
      },
    });
  } catch (error) {
    throw new HttpException(
      manageErrorResponse(
        error as AxiosError<BackendErrorResponse<GenericObj>>,
      ),
    );
  } finally {
  
  }
};

export { initApiRequest };
